import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_ADD_IN_COMPANY_AUTOCOMPLETE_PATH =
  '/outlook_add_in/company_autocomplete';

export type OutlookCompanyJson = {
  id: number;
  name: string;
  logo_thumb_url: string | null;
};

export type OutlookCompanyAutocompleteJson = {
  companies: OutlookCompanyJson[];
};

export const buildOutlookCompanyAutocompletePath = (
  agencyId: number,
  options: {
    query?: string;
  } = {}
): string => {
  const params = new URLSearchParams();
  params.set('agency_id', String(agencyId));
  const query = options.query?.trim();
  if (query) {
    params.set('query', query);
  }
  return `${OUTLOOK_ADD_IN_COMPANY_AUTOCOMPLETE_PATH}?${params.toString()}`;
};

export const fetchOutlookCompanyAutocomplete = async (
  request: PodRequestFn,
  agencyId: number,
  options: {
    query?: string;
  } = {}
): Promise<OutlookCompanyAutocompleteJson> => {
  const path = buildOutlookCompanyAutocompletePath(agencyId, options);
  const response = await request(path);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookCompanyAutocompleteJson;
};
